import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/accountCancelAgreement',
  component: LAYOUT,
  name: 'AccountCancelAgreement',
  redirect: '/accountCancelAgreement/index',
  meta: {
    title: '注销协议',
  },
  children: [
    {
      path: 'index',
      name: 'accountCancelAgreement',
      meta: {
        title: '注销协议',
      },
      component: () => import('@/views/accountCancelAgreement/index'),
    },
  ],
};
